
document.addEventListener("DOMContentLoaded", function () {
    const bgEl = document.querySelector(".js-hero-secondary-bg");
    if (!bgEl) return;
  
    const desktopBg = bgEl.dataset.bgDesktop;
    const phoneBg = bgEl.dataset.bgPhone;
  
    function setBg() {
      const isMobile = window.innerWidth <= 576;
      bgEl.style.backgroundImage = `url('${isMobile ? phoneBg : desktopBg}')`;
    }
  
    setBg();
    window.addEventListener("resize", setBg);
  });
  